export default function buildClientScopeHeader(
  userId: string,
  orgId: string,
  csId: string,
  userName: string,
) {
  return btoa(
    JSON.stringify({
      user_id: userId,
      org_id: orgId,
      cs_id: csId,
      user_name: userName,
    }),
  );
}
